import settings from '/@/core/settings';
import { axFetch, setConverted } from '/@/store/session/actions';
import { getSessionLanguage } from '/@/store/session/selectors';
import { createAction } from '/@/store/utils';

export const getRecommendationPDF = createAction(
    'RECOMMENDATION_PDFS:DOWNLOAD',
    async ({ payload, getState, dispatch }) => {
        const state = getState();
        const language = getSessionLanguage(state);
        const response = await axFetch.post(
            `${settings.urls.apiDomain}/core/v1/recommendation/${payload.recommendation.id}/pdf/link/`,
            {
                async: payload.download ? 'false' : 'true',
                language,
                payload: payload.recommendation,
                ...(payload.version ? { version: payload.version } : {}),
                ...(payload.blocks?.length ? { blocks: payload.blocks } : {}),
            }
        );
        if (response.status === 200) {
            dispatch(setConverted('users_without_shared_recommendations'));
            return response.data;
        }
        throw Error();
    }
);

export const emailRecommendationPDF = createAction(
    'RECOMMENDATION_PDFS:EMAIL',
    async ({ payload, getState, dispatch }) => {
        const state = getState();
        const language = getSessionLanguage(state);
        const response = await axFetch.post(
            `${settings.urls.apiDomain}/core/v1/recommendation/${payload.recommendation.id}/pdf/link/?language=${language}&email=${payload.email}`,
            {
                email: payload.email,
                language,
                payload: payload.recommendation,
                ...(payload.version ? { version: payload.version } : {}),
                ...(payload.blocks?.length ? { blocks: payload.blocks } : {}),
            }
        );

        if (response.status === 200) {
            dispatch(setConverted('users_without_shared_recommendations'));
            return response.data;
        }
        throw Error();
    }
);
